import { useRef, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Button, TextField } from "@mui/material";
import { concatParams, CreateParamsJson } from "../../helper/pathHelper";
import { useLanguage } from "../../i18n/LanguageContext";

// The card name travels inside the shareable link (it's stored in the URL,
// not on a server), so it just needs a sane length — any character is safe
// now that pathHelper percent-encodes every value.
const maxCharacters = 60;

function isExpressionInvalid(str) {
  return Boolean(str) && str.length > maxCharacters;
}

export default function TimeComponent({ path }) {
  const [selectedTime, setSelectedTime] = useState("00:10:00");
  const [selectedTitle, setSelectedTitle] = useState("");
  const nameFieldRef = useRef(null);
  const { t } = useLanguage();

  const json = CreateParamsJson();

  const agenda = json && json.agenda ? JSON.parse(json.agenda) : [];

  const newValue = [
    {
      id: moment().toISOString(),
      topic: selectedTitle,
      time: selectedTime.length === 8 ? selectedTime : `${selectedTime}:00`,
    },
  ];

  const navigate = useNavigate();
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        navigate({
          pathname: path,
          search: concatParams({
            ...json,
            agenda: JSON.stringify(
              newValue ? agenda.concat(newValue) : newValue
            ),
          }),
        });
        setSelectedTitle("");
        // Keep the keyboard open (especially on tablets) so the next card's
        // name can be typed right away instead of re-tapping the field.
        nameFieldRef.current?.focus();
      }}
    >
      <TextField
        variant="standard"
        className="w-100"
        label={t("addCard.name")}
        autoFocus
        inputRef={nameFieldRef}
        error={isExpressionInvalid(selectedTitle)}
        helperText={
          isExpressionInvalid(selectedTitle)
            ? t("addCard.maxCharacters", { count: maxCharacters })
            : ""
        }
        value={selectedTitle}
        onChange={(event) => setSelectedTitle(event.target.value)}
      />
      <div className="addcard-row">
        <TextField
          variant="standard"
          className="addcard-time-field"
          id="time"
          label={t("addCard.timebox")}
          type="time"
          value={selectedTime}
          onChange={(event) => setSelectedTime(`${event.target.value}`)}
          slotProps={{
            htmlInput: {
              step: 1, // 5 min
            },
          }}
        />
        <div className="btn-row">
          <Button
            variant="outlined"
            type="submit"
            disabled={
              selectedTime === "00:00" || isExpressionInvalid(selectedTitle)
            }
          >
            {t("addCard.add")}
          </Button>
        </div>
      </div>
    </form>
  );
}
